import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { ICorrelationCurveChartData } from '@app/api/interfaces/chart-data/correlation-curve';
import { ICorrelationSpectrumChartData } from '@app/api/interfaces/chart-data/correlation-spectrum';

@Injectable({
  providedIn: 'root',
})
export class CorrelationsChartDataApiService {
  constructor(private readonly httpClient: HttpClient) {}

  public getCurve(
    projectId: string,
    correlationId: string
  ): Observable<IApiResponse<ICorrelationCurveChartData, object>> {
    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/correlations/${correlationId}/chart-data/curve`;

    return this.httpClient.get<IApiResponse<ICorrelationCurveChartData, object>>(url, {
      withCredentials: true,
    });
  }

  public getSpectrum(
    projectId: string,
    correlationId: string
  ): Observable<IApiResponse<ICorrelationSpectrumChartData, object>> {
    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/correlations/${correlationId}/chart-data/spectrum`;

    return this.httpClient.get<IApiResponse<ICorrelationSpectrumChartData, object>>(url, {
      withCredentials: true,
    });
  }
}
